import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers, images } from '../data/content';
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let nextTimer: number;
    const show = (i: number) => {
      setIndex(i);
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        nextTimer = window.setTimeout(() => show((i + 1) % buyers.length), GAP);
      }, SHOW_FOR);
    };
    const start = window.setTimeout(() => show(Math.floor(Math.random() * buyers.length)), FIRST_DELAY);
    return () => {
      window.clearTimeout(start);
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed left-3 right-3 top-3 z-50 flex justify-center sm:bottom-24 sm:left-5 sm:right-auto sm:top-auto sm:justify-start" aria-live="polite" data-id="element-290" data-mp="1fw25m3ttclik">
      <AnimatePresence data-id="element-291" data-mp="n6v5j0epnnv7">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(11,27,51,0.22)] ring-1 ring-navy/10" data-id="element-292" data-mp="n97mba8qfs6o">
            <img src={images.mainMockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-cover" data-id="element-293" data-mp="23kv52a9n9bhx" />
            <div className="min-w-0 text-left" data-id="element-294" data-mp="2aobhcxoyyj19">
              <p className="text-sm leading-snug text-navy" data-id="element-295" data-mp="2fn4rqh8yltx7">
                <strong data-id="element-296" data-mp="2fpqxcbcahzcs">{buyer.name}</strong> from {buyer.country} <span aria-hidden="true" data-id="element-297" data-mp="2knsj5413ocry">{buyer.flag}</span>
              </p>
              <p className="text-[13px] leading-snug text-ink-muted" data-id="element-298" data-mp="2plkd03lb28ys">just purchased Oral Rehabilitation Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-cta" data-id="element-299" data-mp="1ryv2t6gg8q1u">
                <CheckCircle2Icon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-300" data-mp="1wwdeh4lupjdj" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-ink-muted transition-colors duration-150 ease-out hover:bg-cream hover:text-navy" data-id="element-301" data-mp="26mzmodr8n7m7">
              <XIcon className="h-4 w-4" data-id="element-302" data-mp="3rgonrr9v7z7t" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}